<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd"/>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :isFirstValue="false"
            type="search"
            label="부서"
            name="deptCd"
            v-model="searchParam.deptCd"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-multi-field
            isArray
            label="점검자"
            name="checkUserIds"
            v-model="searchParam.checkUserIds"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="순회기간"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            stepperGrpCd="PATROL_STEP_CD"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="patrolStepCd"
            label="진행단계"
            v-model="searchParam.patrolStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="card-body qtable-card-body">
      <q-table
        grid
        class="qtable-card"
        title=""
        :data="grid.data"
        :columns="grid.columns"
        hide-header
        hide-bottom
        :rows-per-page-options="[0]"
        virtual-scroll
      >
        <template v-slot:top-right>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
            <q-card class="mobileTableCardLayer" @click="linkClick(null,props.row)">
              <q-card-section class="grid-card-etc">
                <div :class="['text-grid-etc', getColorStatus(props.row.patrolStepCd)]">
                  {{ props.row.patrolStepName }}
                </div>
              </q-card-section>
              <q-card-section>
                <div class="text-grid-title q-mt-sm q-mb-xs">{{ props.row.patrolName }}</div>
              </q-card-section>
              <q-card-section class="grid-card-etc">
                <div class="text-grid-etc">
                  {{ props.row.patrolStartDate }} | {{ props.row.deptName }} | {{ props.row.checkUserName }} | {{!props.row.completeCount ? '0건' : props.row.completeCount + '건' }}
                </div>
              </q-card-section>
            </q-card>
          </div>
        </template>
      </q-table>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
        <q-card class="mobileTableCardLayer">
          <q-card-section class="text-center">
            <q-card-section class="q-pt-xs">
              <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
            </q-card-section>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'patrol',
  data() {
    return {
      searchParam: {
        plantCd: null,
        deptCd: null,
        period: [],
        checkUserIds: [],
        startYmd: '',
        endYmd: '',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
            style: 'width:120px',
          },
          {
            name: 'patrolName',
            field: 'patrolName',
            label: '순회명',
            align: 'left',
            sortable: true,
            type: 'link',
            style: 'width:300px',
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '점검주관부서',
            align: 'center',
            sortable: true,
            style: 'width:120px',
          },
          {
            name: 'patrolStartDate',
            field: 'patrolStartDate',
            label: '순회일',
            align: 'center',
            sortable: true,
            style: 'width:150px',
          },
          {
            name: 'patrolStepName',
            field: 'patrolStepName',
            label: '진행상태',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      searchUrl: '',
      editable: true,
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  beforeRouteLeave(to, from, next) { // history.back 일경우 팝업이라면 팝업을 닫자
    if (this.popupOptions.visible) {
      this.closePopup();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.patrol.list.url;
      // code setting
      this.searchParam.patrolStepCd = null;
      // list setting
      this.getList();
    },
    getColorStatus(cd) {
      var cls = '';
      switch(cd) {
        case 'PS00000001': // 계획중
          cls = 'txt-box-grid text-primary-box';
          break;
        case 'PS00000005': // 결과작성중
          cls = 'txt-box-grid text-positive-box';
          break;
        case 'PS00000010': // 완료
          cls = 'txt-box-grid text-orange-box';
          break;
      }
      return cls;
    },
    getList() {
      if (this.searchParam.period && this.searchParam.period[0]) {
        this.searchParam.startYmd = this.searchParam.period[0];
        this.searchParam.endYmd = this.searchParam.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    openPopup() {
      this.linkClick();
    },
    /* eslint-disable no-unused-vars */
    linkClick(evt, row) {
      this.popupOptions.title = '순회점검 상세'; // 순회점검 상세
      this.popupOptions.param = {
        saiPatrolId: row ? row.saiPatrolId : '',
      };
      this.popupOptions.target = () => import(`${'./patrolDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
